// extracted by mini-css-extract-plugin
module.exports =  {"profile":"profile"};